import React from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentUserRole } from '../../helpers/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRole = 'admin',
  redirectTo = '/login' 
}) => {
  // const userRole = getCurrentUserRole();
  const userRole = "admin";
  
  // Check if user is authenticated
  if (!userRole) {
    return <Navigate to={redirectTo} replace />;
  }
  
  // Check if user has required role
  if (requiredRole && userRole.toLowerCase() !== requiredRole.toLowerCase()) {
    return <Navigate to="/" replace />;
  }
  
  return <>{children}</>;
};

export default ProtectedRoute;
